import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import { useParams } from "react-router-dom";
import { travelApi } from "functions/apis";

const useStyles = makeStyles(styles);

const ViewMerchantInventoryControlGroup = props => {
  const classes = useStyles();

  const [input, setInput] = useState({
    code: "",
    name: ""
  });

  const { id } = useParams();

  const viewMerchantInventoryControlGroupSignal = useRef(new AbortController());

  useEffect(() => {
    return () => viewMerchantInventoryControlGroupSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      travelApi
        .get("inventoryControlGroups/" + id, {
          signal: viewMerchantInventoryControlGroupSignal.current.signal
        })
        .then(resp => {
          setInput(resp);
        });
    }
  }, [id]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              VIEW MERCHANT INVENTORY CONTROL GROUP
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form>
              <CustomInput
                labelText="Code"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: input.code,
                  disabled: true
                }}
              />
              <CustomInput
                labelText="Name"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: input.name,
                  disabled: true
                }}
              />
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default ViewMerchantInventoryControlGroup;

ViewMerchantInventoryControlGroup.propTypes = {
  history: PropTypes.object
};
